<template>
  <div class="to-agnet">
    <!--為單一服務時間 + 非服務時務時間時-->
    <div v-if="!botRoom.isServiceTime && botRoom.isSingleServiceTime">
      <div
        class="text"
        :class="{ client: message.chatUserRole === 'Customer' }"
      >
        <div
          class="content gpt-ql-editor"
          v-html="setting.ChatGPT_NonService_Reply"
        ></div>
        <div class="time">{{ message.createAt | localTime }}</div>
      </div>
      <div class="btns" :class="{ disabled: botRoom.isFinished }">
        <a
          v-if="setting.ChatGPT_NonService_Title_1"
          :href="setting.ChatGPT_NonService_Url_1 || '#'"
          target="_blank"
          class="primary"
          >{{ setting.ChatGPT_NonService_Title_1 }}</a
        >
        <a
          v-if="setting.ChatGPT_NonService_Title_2"
          :href="setting.ChatGPT_NonService_Url_2 || '#'"
          target="_blank"
          class="primary"
          >{{ setting.ChatGPT_NonService_Title_2 }}</a
        >
      </div>
    </div>

    <div v-else>
      <div
        class="text"
        :class="{ client: message.chatUserRole === 'Customer' }"
      >
        <div class="content gpt-ql-editor" v-html="message.content"></div>
        <div class="time">{{ message.createAt | localTime }}</div>
      </div>

      <div class="btns">
        <button
          class="primary"
          @click="transferToAgent"
          :aria-label="$t('GPT.LAYOUT.TRANSFER_TOAGENT')"
          tabindex="0"
        >
          {{ $t("GPT.LAYOUT.TRANSFER_TOAGENT") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gpt-message-toAgent",
  props: {
    message: {
      type: Object,
    },
  },
  data() {
    return {
      display: true,
    };
  },
  methods: {
    transferToAgent() {
      if (this.botRoom.isFinished) {
        return;
      }
      window.dataLayer.push({
        event: "data_layer_event",
        chatbot_session_id: this.chatbot_session_id,
        event_name_ga4: "to_agent_genio",
        event_category_DL: "genio",
        event_action_DL: "clicked",
        event_label_DL: "to_agent",
      });
      this.$store.dispatch("gpt/transferToAgent");
    },
  },
  computed: {
    setting() {
      return this.$store.state.gpt.setting;
    },
    botRoom() {
      return this.$store.state.gpt.botRoom;
    },
    chatbot_session_id() {
      return this.$store.getters["gpt/chatbot_session_id"];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "gpt.scss";
</style>
